import { BulkEditOption } from './types';

export const OptionsConstants = Object.freeze({
  OPTIONS: [
    {
      label: 'Edit CPI',
      selectedLabel: 'CPI',
      type: 'cpi',
      config: 'overridCmp',
    },
    { label: 'Edit Status', selectedLabel: 'Status', type: 'status' },
    {
      label: 'Edit Margin',
      selectedLabel: 'Margin',
      type: 'margin',
      role: 'service-buyer',
      config: 'enableTargetMargin',
    },
    {
      label: 'Edit Billing Number',
      selectedLabel: 'Billing Number',
      type: 'billingNumber',
    },
    {
      label: 'Edit Project Manager',
      selectedLabel: 'Project Manager',
      type: 'projectManager',
      role: 'buyer',
    },
    {
      label: 'Edit Buyer Project Manager',
      selectedLabel: 'Buyer Project Manager',
      type: 'projectManager',
      role: 'service-buyer',
    },
    {
      label: 'Edit Operator Project Manager',
      selectedLabel: 'Operator Project Manager',
      type: 'accountManager',
      role: 'service-buyer',
    },
    {
      label: 'Group Surveys',
      selectedLabel: 'Group Surveys',
      type: 'groupSurveys',
      visibility: ['ALL', 'LIVE', 'PAUSED', 'CLOSED'],
      roles: ['operator', 'service-buyer', 'buyer'],
    },
    {
      label: 'Delete Draft Surveys',
      selectedLabel: 'Delete Draft Surveys',
      type: 'deleteDraft',
      visibility: ['DRAFTS'],
    },
    {
      label: 'Download Combined Survey Traffic Report',
      selectedLabel: 'Combined Survey Traffic Report',
      type: 'combinedReport',
    },
    {
      label: 'Download Combined Summary Report',
      selectedLabel: 'Combined Summary Report',
      type: 'supplierSummary',
    },
  ] as BulkEditOption[],
  FIELDS: {
    cpi: {
      key: 'cpi',
      label: '',
      input: 'number',
      placeholder: '',
      confirm: 'Confirm',
      class: 'sm',
      dollarSymbol: true,
      changeValue: '',
    },
    billingNumber: {
      key: 'billingNumber',
      label: '',
      placeholder: 'Billing Number',
      class: 'xl',
      changeValue: '',
    },
    accountManager: {
      key: 'accountManager',
      label: '',
      placeholder: 'Enter Account Manager Name',
      confirm: 'Confirm',
      class: 'lg',
      changeValue: '',
    },
    projectManager: {
      key: 'projectManager',
      label: '',
      placeholder: 'Enter Project Manager Name',
      confirm: 'Confirm',
      class: 'lg',
      changeValue: '',
    },
    status: {
      key: 'status',
      label: '',
      placeholder: 'Enter Status',
      class: 'md',
      changeValue: '',
    },
    margin: {
      key: 'margin',
      label: '',
      input: 'number',
      placeholder: '',
      class: 'sm',
      changeValue: '',
    },
    combinedReport: {
      key: 'combinedReport',
      label: '',
      placeholder: 'PS#ProjectID#',
      class: 'md',
      changeValue: '',
      confirm: 'Download',
    },
    supplierSummary: {
      key: 'supplierSummary',
      label: '',
      placeholder: 'Enter Supplier Summary Value',
      class: 'md',
      changeValue: '',
      confirm: 'Download',
    },
    deleteDraft: {
      key: 'deleteDraft',
      label: '',
      placeholder: '',
      class: 'md',
      changeValue: 'delete',
    },
    groupSurveys: {
      key: 'groupSurveys',
      label: 'Group Surveys - Title',
      placeholder: 'Group Title',
      class: 'lg',
      changeValue: '',
    },
  },
});

export const BulkEditConstants = Object.freeze({
  BILLING_ID_MAX_LENGTH: 16,
});

export const GROUP_TITLE_MAX_LENGTH = 255;
